<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-left">Pregunta</th>
          <th class="text-left">Respuesta</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="pair in pairs" :key="pair.id">
          <td>{{ pair.question }}</td>
          <td>{{ pair.answer }}</td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'QuestionnaireAnswer',
  props: ['pairs'],
  data () {
    return {
      headers: [
        { text: 'Pregunta', value: 'question' },
        { text: 'Respuesta', value: 'answer' },
      ],
    }
  },
}
</script> 